import { readContracts, } from "wagmi/actions";
import { wagmiConfig, } from "@config";
import type { TokenDefinition,  } from "@bracket/addressbook";
import * as C from "@contracts";



export declare type SwapProps = {
	token: TokenDefinition;
	amount: number | string;
};

let debounce:NodeJS.Timeout;

export const quote = async ({ token, amount, }: SwapProps): Promise<bigint> => {
	return new Promise( ( resolve, reject ) => {
		if( debounce ) clearTimeout(debounce);
		debounce = setTimeout( async () => {
			try {
				const nAmount = typeof amount === "string" ? Number(amount) : amount;
				const { fees, } = token;
				const feesArr = Array.isArray(fees) ? fees : [ fees ];
				if( Array.isArray(feesArr) && feesArr.length ) {
					const quotes = await readContracts(
						wagmiConfig, {
							contracts: feesArr.map(fee => {
								return C.IEscrowRouter.uniswapQuote(
									Object.assign({}, token, { fee, }),
									nAmount
								);
							}
						)
					});

					// console.log("EscrowStore:resolve:quote | quotes", quotes);

					const result = quotes.reduce(( acc, result, ) => {
						return result.status === "success" && Number(result.result) > acc ? result.result : BigInt(acc)
					}, 0);

					if( typeof result === "bigint") {
						// console.log(`raw contract result returned for ${nAmount}:`, result, n(result));
						return resolve(result);
					}
					throw new Error("failed to elect a quote - result is not a bigint");
				}
				throw new Error(`token ${token.label} does not have a applicable fees list`);
			}
			catch (err) {
				reject(new Error(`@bracket/stake-app::resolver "quote" has failed - ${err instanceof Error ? err.message : "no error instance"}`));
			}

		}, 250);
	})

};
	
